// Load the appropriate stylesheet based on the environment variable
export function loadStylesheet(stylesheet, renderApp) {
  const link = document.createElement("link");
  link.rel = "stylesheet";

  switch (stylesheet) {
    case "stylesheet1":
      link.href = "/styles/Stylesheet1.css";
      break;
    case "stylesheet2":
      link.href = "/styles/Stylesheet2.css";
      break;
    case "stylesheet3":
      link.href = "/styles/Stylesheet3.css";
      break;
    case "stylesheet4":
      link.href = "/styles/Stylesheet4.css";
      break;
    default:
      console.warn(
        `Unknown STYLESHEET: ${stylesheet}, falling back to stylesheet1`
      );
      link.href = "/styles/Stylesheet1.css";
  }

  // Only renders the app after the stylesheet has loaded or failed to load
  link.onload = () => {
    renderApp();
  };

  link.onerror = () => {
    console.error(`❌ Failed to load stylesheet: ${link.href}`);
    renderApp();
  };

  // Append the link element to the document head
  document.head.appendChild(link);
}
